export default __webpack_public_path__ + "static/banner_yck-8e250edb134ba643bdb1fd1695fb9807.jpg";